import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ew-list-loader',
  templateUrl: './ew-list-loader.component.html',
  styleUrls: ['./ew-list-loader.component.css']
})
export class EwListLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
